import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Send the auth cookie on every request (login gate).
axios.defaults.withCredentials = true;
export const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
